export const CheckIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.6818 7L8.68182 14L5.5 10.8182" stroke="#14191F" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
